import { aiHttpClient } from '../../../Common/api/ai_http_client';
import * as Helper from './helper';

/**
 *
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export function uploadMerchantFiles(payload) {
  // const formData = Helper.createUploadFormData(files);
  console.log(payload)
  return aiHttpClient.post('/files/upload', payload, {
    'Content-Type': 'multipart/form-data'
  });
}

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getUploadedFile() {
  return aiHttpClient.get('/files/download');
}
